import { render, staticRenderFns } from "./ModalAddClass.vue?vue&type=template&id=770137d5&scoped=true"
import script from "./ModalAddClass.vue?vue&type=script&lang=js"
export * from "./ModalAddClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770137d5",
  null
  
)

export default component.exports